import { Player, PlayerOrNone } from '../../jscaip/Player';
export class LodestonePieceNone {
    unreachable;
    static UNREACHABLE = new LodestonePieceNone(true);
    static EMPTY = new LodestonePieceNone(false);
    owner = PlayerOrNone.NONE;
    constructor(unreachable) {
        this.unreachable = unreachable;
    }
    isLodestone() {
        return false;
    }
    isPlayerPiece() {
        return false;
    }
    isEmpty() {
        return true;
    }
    isUnreachable() {
        return this.unreachable;
    }
    equals(other) {
        return this === other;
    }
}
export class LodestonePiecePlayer {
    owner;
    static ZERO = new LodestonePiecePlayer(Player.ZERO);
    static ONE = new LodestonePiecePlayer(Player.ONE);
    static of(player) {
        if (player === Player.ZERO) {
            return LodestonePiecePlayer.ZERO;
        }
        else {
            return LodestonePiecePlayer.ONE;
        }
    }
    constructor(owner) {
        this.owner = owner;
    }
    isLodestone() {
        return false;
    }
    isPlayerPiece() {
        return true;
    }
    isEmpty() {
        return false;
    }
    isUnreachable() {
        return false;
    }
    equals(other) {
        return this === other;
    }
}
export class LodestonePieceLodestone {
    owner;
    direction;
    orientation;
    static ZERO_PUSH_DIAGONAL = new LodestonePieceLodestone(Player.ZERO, 'push', 'diagonal');
    static ZERO_PUSH_ORTHOGONAL = new LodestonePieceLodestone(Player.ZERO, 'push', 'orthogonal');
    static ZERO_PULL_DIAGONAL = new LodestonePieceLodestone(Player.ZERO, 'pull', 'diagonal');
    static ZERO_PULL_ORTHOGONAL = new LodestonePieceLodestone(Player.ZERO, 'pull', 'orthogonal');
    static ONE_PUSH_DIAGONAL = new LodestonePieceLodestone(Player.ONE, 'push', 'diagonal');
    static ONE_PUSH_ORTHOGONAL = new LodestonePieceLodestone(Player.ONE, 'push', 'orthogonal');
    static ONE_PULL_DIAGONAL = new LodestonePieceLodestone(Player.ONE, 'pull', 'diagonal');
    static ONE_PULL_ORTHOGONAL = new LodestonePieceLodestone(Player.ONE, 'pull', 'orthogonal');
    static LODESTONES = {
        0: {
            'push': {
                'diagonal': LodestonePieceLodestone.ZERO_PUSH_DIAGONAL,
                'orthogonal': LodestonePieceLodestone.ZERO_PUSH_ORTHOGONAL,
            },
            'pull': {
                'diagonal': LodestonePieceLodestone.ZERO_PULL_DIAGONAL,
                'orthogonal': LodestonePieceLodestone.ZERO_PULL_ORTHOGONAL,
            },
        },
        1: {
            'push': {
                'diagonal': LodestonePieceLodestone.ONE_PUSH_DIAGONAL,
                'orthogonal': LodestonePieceLodestone.ONE_PUSH_ORTHOGONAL,
            },
            'pull': {
                'diagonal': LodestonePieceLodestone.ONE_PULL_DIAGONAL,
                'orthogonal': LodestonePieceLodestone.ONE_PULL_ORTHOGONAL,
            },
        },
    };
    constructor(owner, direction, orientation) {
        this.owner = owner;
        this.direction = direction;
        this.orientation = orientation;
    }
    static of(player, description) {
        return LodestonePieceLodestone.LODESTONES[player.getValue()][description.direction][description.orientation];
    }
    isLodestone() {
        return true;
    }
    isPlayerPiece() {
        return false;
    }
    isEmpty() {
        return false;
    }
    isUnreachable() {
        return false;
    }
    equals(other) {
        return this === other;
    }
}
